<template>
    <div>
        <van-nav-bar class="header" :title="activityTheme" left-arrow @click-left="onClickLeft" fixed/>
        <div class="content">
            <img :src="imgUrl + id" class="activityPoster" alt="">
            <div class="btn-box">
                <van-button plain type="info" id="" @click="myCustomer">我的客户</van-button>
                <van-button type="default" id="shareBtn" @click="shareImg">分享</van-button>
            </div>
        </div>

    </div>
</template>

<script>
    import {Button,NavBar} from 'vant';
    import {API_URL} from "../../common/config";

    export default {
        data: function () {
            return {
                activityTheme:'活动详情',
                imageUrl:'',
                id:'',
            }
        },
        components: {
            [Button.name]: Button,
            [NavBar.name]: NavBar,
        },
        computed: {
            imgUrl() {
                return API_URL + "/crm/activity/generateActivityQRCode?uuid=";
            },
        },
        mounted: async function() {
            this.id = this.$route.query.id;
        },
        methods:{
            onClickLeft() {
                this.$router.go(-1);
            },
            myCustomer() {
                this.$router.push({path:"MyCustomer",query:{id:this.id}})
            },
            shareImg() {
                window.location.href = '/shareImg?imgUrl=' + this.imgUrl + this.id;
            }
        }
    };

</script>
<style scoped>
    .header {
        height:120px;
    }
    .van-nav-bar__left {
        height:100%;
    }
    .van-nav-bar__left i {
        font-size:1.5rem;
    }
    .content {
        margin-top: 120px;
    }
    .activityPoster {
        width:100%;
    }
    .btn-box {
        display: flex;
        justify-content: space-around;
        padding:30px 0;
    }
    .btn-box button {
        width:240px;
    }

</style>
